export default __webpack_public_path__ + "static/media/dev.40a0346b.gif";